import {get} from 'lodash';

export default (state = {}, {stepName}: any) => {
  return {
    ...state,
    completedSteps: {
      ...get(state, 'completedSteps', {}),
      [stepName]: true,
    },
  };
};
